/**
 * BGM 背景音乐公开配置 API
 * 获取公开可用的 BGM 曲目列表与默认选中配置
 */

import axiosInstance from "../services/axiosConfig";
import { API_PATHS, STORAGE_KEYS } from "./config";
import Logger from "../utils/logger";

/** 系统内置保底曲库（网络异常或未拉取到时的后备） */
export const DEFAULT_BGM_TRACKS = [
  {
    key: "deliberate_thought",
    name: "灵动探索",
    desc: "3Blue1Brown 经典同款风格，清澈马林巴木琴与轻钢琴，适合数学、微积分、几何推导",
    url: "/bgm/deliberate_thought.mp3",
  },
  {
    key: "water_lily",
    name: "沉静思考",
    desc: "极简舒缓纯钢琴，适合深思难题、长公式证明、复杂定理拆解",
    url: "/bgm/water_lily.mp3",
  },
  {
    key: "carefree",
    name: "轻松启发",
    desc: "轻快跳跃马林巴与木吉他，适合趣味科普、生动教学与概念入门",
    url: "/bgm/carefree.mp3",
  },
  {
    key: "daily_beetle",
    name: "温暖陪伴",
    desc: "温暖木吉他声学风，消除枯燥与学习焦虑感，自习室陪伴感",
    url: "/bgm/daily_beetle.mp3",
  },
];

/**
 * 从本地缓存获取 BGM 配置
 */
export const getCachedBgmConfig = () => {
  try {
    const cached = JSON.parse(localStorage.getItem(STORAGE_KEYS.BGM_PUBLIC_CONFIG) || "null");
    return cached && typeof cached === "object" ? cached : null;
  } catch (error) {
    Logger.warn("读取 BGM 配置缓存失败", error);
    return null;
  }
};

/**
 * 从服务器拉取公开的 BGM 配置并更新缓存
 * @returns {Promise<object>}
 */
export const getPublicBgmConfig = async () => {
  try {
    const response = await axiosInstance.get(
      `${API_PATHS.BASE_API_URL}${API_PATHS.BGM.GET_PUBLIC_CONFIG}`
    );

    if (response?.success && response.data) {
      try {
        localStorage.setItem(STORAGE_KEYS.BGM_PUBLIC_CONFIG, JSON.stringify(response.data));
      } catch (error) {
        Logger.warn("写入 BGM 配置缓存失败", error);
      }
    }

    return response;
  } catch (error) {
    Logger.error("获取公开 BGM 配置异常", error);
    const cached = getCachedBgmConfig();
    return {
      success: false,
      data: cached || {
        enabled: true,
        default_bgm: "deliberate_thought",
        tracks: DEFAULT_BGM_TRACKS,
      },
    };
  }
};
